import * as tslib_1 from "tslib";
import { call, put, takeEvery } from 'redux-saga/effects';
import { initialize } from './actionCreators';
import { requestFailure, requestSuccess } from './actionCreators';
import { request } from '../../xhr';
function getFakeData(_a) {
    var username = _a.params.username;
    if (process.env.NODE_ENV !== 'production') {
        var _b = require('@wix/da-sample-data'), users = _b.users, deviationsByType = _b.deviationsByType, Fake = _b.Fake, deviations = _b.deviations;
        var Chance = require('chance').Chance;
        var chance = new Chance();
        var data = {
            user: tslib_1.__assign({}, (users.find(function (u) { return u.username === username; }) || chance.pickone(users)), { username: username, profile: {
                    tagline: 'Digital Artist',
                    profilePic: chance.pickone(deviationsByType.image),
                }, stats: {
                    watchers: chance.natural({ max: 40000 }),
                    friends: chance.natural({ max: 1000 }),
                } }),
            deviationsCount: chance.natural({ max: 999 }),
            description: Fake.makeEditorText(),
            featuredDeviations: chance.pickset(deviations, 10),
        };
        return data;
    }
    return false;
}
function handleInitialize(action) {
    var username, result;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                username = action.payload.username;
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: 'user/info',
                        params: { username: username, expand: 'user.stats,user.profile,user.watch' },
                    }, getFakeData)];
            case 1:
                result = _a.sent();
                if (!result) return [3 /*break*/, 3];
                return [4 /*yield*/, put(requestSuccess(username, result))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, put(requestFailure(username))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
export default function userAvatarTooltipRootSaga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeEvery(initialize, handleInitialize)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map